import { render, staticRenderFns } from "./ModificaDatiPartner.vue?vue&type=template&id=4c794ffe&scoped=true&"
import script from "./ModificaDatiPartner.vue?vue&type=script&lang=js&"
export * from "./ModificaDatiPartner.vue?vue&type=script&lang=js&"
import style0 from "./ModificaDatiPartner.vue?vue&type=style&index=0&id=4c794ffe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c794ffe",
  null
  
)

export default component.exports